/**
 * Utility for displaying notifications in the application
 */

/**
 * Shows a notification to the user
 * @param {string} message - The message to display
 * @param {string} severity - The severity level (success, error, warning, info)
 * @param {number} duration - Duration in milliseconds
 */
export const showNotification = (message, severity = 'info', duration = 5000) => {
  // This will be connected to the application's notification system
  // For now, using console.log as a fallback
  console.log(`[${severity.toUpperCase()}] ${message}`);
  
  // Dispatch to notification system if available
  if (window.dispatchEvent) {
    const event = new CustomEvent('show-notification', { 
      detail: { message, severity, duration } 
    });
    window.dispatchEvent(event);
  }
};
